//@flow
import * as Immutable from 'immutable';

import {
    RouteRestriction,
    VehicleModelId,
    RestrictedDaysMap
} from 'common/models/flow/RouteRestriction';
import type {
    RouteRestrictionModelType,
    VehicleModelIdModelType,
    RestrictedDaysMapModelType
} from 'common/models/flow/RouteRestriction';
import { LocalTimeSlot } from './LocalTimeSlot';

import { LatLng } from './LatLng';

import { LatLngLineSegments, CompositeLatLngPolygon } from './Geometry';

class InternalRouteRestriction extends RouteRestriction {
    static fromJS(json: RouteRestrictionModelType): InternalRouteRestriction {
        const state: Object = Object.assign({}, json);
        state.center = LatLng.fromJS(state.center);
        state.polygon = state.polygon
            ? CompositeLatLngPolygon.fromJS(state.polygon)
            : state.polygon;
        state.timeSlots = Immutable.List(state.timeSlots).map(item =>
            LocalTimeSlot.fromJS(item)
        );
        state.vehicleModelIds = Immutable.List(
            state.vehicleModelIds
        ).map(item => InternalVehicleModelId.fromJS(item));
        state.vehicleTypes = Immutable.List(state.vehicleTypes);
        state.vehicleSkills = Immutable.List(state.vehicleSkills);
        state.lineSegments = state.lineSegments
            ? LatLngLineSegments.fromJS(state.lineSegments)
            : state.lineSegments;
        state.restrictedDaysMap = InternalRestrictedDaysMap.fromJS(
            state.restrictedDaysMap
        );
        state.restrictedDatesMap = InternalRestrictedDaysMap.fromJS(
            state.restrictedDatesMap
        );
        state.vehicleNumbers = Immutable.List(state.vehicleNumbers);
        state.daysForRestrictedDates = Immutable.List(
            state.daysForRestrictedDates
        );
        return new this(Immutable.Map(state));
    }

    get center(): LatLng {
        return this._state.get('center');
    }

    get polygon(): ?CompositeLatLngPolygon {
        return this._state.get('polygon');
    }

    get lineSegments(): ?LatLngLineSegments {
        return this._state.get('lineSegments');
    }

    get timeSlots(): Immutable.List<LocalTimeSlot> {
        return this._state.get('timeSlots');
    }

    get vehicleModelIds(): Immutable.List<VehicleModelId> {
        return this._state.get('vehicleModelIds');
    }

    get restrictedDaysMap(): InternalRestrictedDaysMap {
        return this._state.get('restrictedDaysMap');
    }

    get restrictedDatesMap(): InternalRestrictedDaysMap {
        return this._state.get('restrictedDatesMap');
    }
}

class InternalVehicleModelId extends VehicleModelId {
    static fromJS(json: VehicleModelIdModelType): InternalVehicleModelId {
        const state: Object = Object.assign({}, json);
        return new this(Immutable.Map(state));
    }
}

class InternalRestrictedDaysMap extends RestrictedDaysMap {
    static fromJS(json: RestrictedDaysMapModelType): InternalRestrictedDaysMap {
        const state: Object = Object.assign({}, json);
        return new this(Immutable.Map(state));
    }
}

export {
    InternalRouteRestriction as RouteRestriction,
    InternalVehicleModelId as VehicleModelId,
    InternalRestrictedDaysMap as RestrictedDaysMap
};
